export default "__VITE_ASSET__CW8IB2Au__"